import {
  WAREHOUSE,
} from '../actions/constants';

const initialState = {
  handling: false,
  data: {},
};

export default function warehouse(state = initialState, action) {
  switch (action.type) {
    case WAREHOUSE.handlers.fetch:
    case WAREHOUSE.handlers.update:
    case WAREHOUSE.handlers.remove:
      return {
        ...state,
        handling: true,
      };
    case WAREHOUSE.update:
      return {
        ...state,
        data: action.merge ? {
          ...state.data,
          ...action.data,
        } : action.data,
        handling: false,
      };
    default:
      return state;
  }
}
